<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Our Impact" subtitle="Our Impact"></app-page-banner>
        <div class="container">

            <div class="row align-items-center ">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <div class="image-container text-center">
                        <img src="assets/images/impact.jpg" alt="Welcome to Soul Space"
                            class="img-fluid rounded-img shadow-img">
                    </div>
                </div>

                <!-- Right Side: Text Content -->
                <div class="col-lg-6 col-md-12">
                    <div class="text-content">
                        <div class="separator-line mb-4"></div>
                        <h5>Our Impact
                        </h5>
                        <p>
                            Since our inception, Soul Space has
                        <p>
                        <ul class="centered-list">
                            <li>Reduce stigma around mental health in educational settings.</li>
                            <li>Empower students with self-awareness and emotional regulation skills.</li>
                            <li>Provide early intervention and support for mental health challenges.</li>
                            <li>Foster a culture of empathy and understanding in school.</li>
                            <li>Equip educators with the resources to support students' emotional needs.</li>
                        </ul>
                        <p>
                            We're proud of our achievements, but we're just getting started. Join us in our mission to
                            create a world where every student has the emotional tools they need to thrive in this
                            challenging world

                        </p>


                    </div>
                </div>
            </div>

        </div>


    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>